import React, { useState } from "react";
import {
  Form,
  Button,
  Card,
  Row,
  Col,
  Container,
  Table,
} from "react-bootstrap";
import Swal from "sweetalert2";

import NsdlPanCardService from "../../../services/NsdlPanCardService";
import SideBar from "../../../components/Sidebar";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";

const PanStatus = () => {
  const [ackNo, setAckNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);

  const validateAndProceed = () => {
    if (!ackNo || ackNo.length !== 15) {
      Swal.fire(
        "Invalid!",
        "Please enter a valid 15-digit Ack Number",
        "warning"
      );
      return;
    }
    handlePANStatus();
  };

  const handlePANStatus = async () => {
    if (loading) return;

    setLoading(true);

    try {
      const result = await NsdlPanCardService.panStatus(ackNo);

      if (!result.success) {
        Swal.fire("Oops!", result.message || "Request failed!", "error");
        return;
      }

      const res = result.data;

      if (res.status === "SUCCESS") {
        setResponseData(res.data);
      } else {
        Swal.fire("Oops!", res.message || "Something went wrong", "error");
      }
    } catch (error) {
      Swal.fire(
        "Oops!",
        error.response?.data?.message || error.message || "Network error",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="mt-3">
      {loading && <LoadingScreen />}

      <Row>
        <SideBar />

        <Col md={9}>
          <Card className="shadow-sm p-3" style={{ borderRadius: "12px" }}>
            <h4 className="mb-4 text-center">PAN Status Check</h4>

            <Row className="mb-3">
              <Col md={8}>
                <Form.Group>
                  <Form.Label>Acknowledgement Number</Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={15}
                    placeholder="Enter 15-digit Ack Number"
                    value={ackNo}
                    onChange={(e) => setAckNo(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={4} className="d-flex align-items-end">
                <Button
                  variant="primary"
                  className="w-100"
                  onClick={validateAndProceed}
                >
                  Submit
                </Button>
              </Col>
            </Row>

            {/* RESULT TABLE IN SAME CARD */}
            {responseData && (
              <div className="mt-4">
                <h5 className="mb-3 text-center">PAN Status Details</h5>

                <Table bordered hover responsive>
                  <tbody>
                    <tr>
                      <th width="40%">Acknowledgement Number</th>
                      <td>{responseData.ack_no || ackNo}</td>
                    </tr>

                    <tr>
                      <th>Status</th>
                      <td>{responseData.pan_status || "N/A"}</td>
                    </tr>

                    <tr>
                      <th>PAN Number</th>
                      <td>{responseData.pan_no || "N/A"}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PanStatus;
